// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

<template>
  <div class="vpn-details">
    <a-spin :spinning="loading">
      <div v-if="remoteAccessVpn">
        <div>
          <p>{{ $t('message.enabled.vpn') }} <strong><a target="_blank" :href="'https://' + remoteAccessVpn.publichostname + ':' + remoteAccessVpn.publicport" >https://{{ remoteAccessVpn.publichostname }}:{{ remoteAccessVpn.publicport }}</a></strong></p>
          <p>{{ $t('message.enabled.vpn.mgmt.pwd') }} <strong>{{ remoteAccessVpn.presharedkey }}</strong></p>
          <p>{{ $t('message.enabled.vpn.ip.range') }} <strong>{{ remoteAccessVpn.iprange }}</strong></p>
          <a-divider/>
          <div>
            <h4 style="display: inline-block; margin: 2px">{{ $t('label.static.routes') }}</h4>
            <a-button
              type="primary"
              @click="addRoute = true">
              <plus-outlined />
            </a-button>
          </div>
          <br/>
          <a-list size="large" class="list">
            <a-list-item :key="index" v-for="(route, index) in routes" class="item">
              <a-list-item-meta>
                <template #title>
                    {{ route.value }} <span style="float: right">{{ route.title }}</span>
                </template>
              </a-list-item-meta>
              <template #actions class="action">
                <a-button
                  shape="circle"
                  type="danger"
                  @click="this.deleteRoute(route)"
                  v-if="!route.default">
                  <delete-outlined />
                </a-button>
              </template>
            </a-list-item>
          </a-list>
          <a-divider/>
          <a-button><router-link :to="{ path: '/vpnuser'}">{{ $t('label.manage.vpn.user') }}</router-link></a-button>
          <a-button
            style="margin-left: 10px"
            @click="() => { setManagementIp = true }"
            :disabled="!('updateRemoteAccessVpn' in $store.getters.apis)">
            {{ $t('label.set.management.ip') }}
          </a-button>
          <a-button
            style="margin-left: 10px"
            @click="updateRemoteAccessVpn"
            :disabled="!('updateRemoteAccessVpn' in $store.getters.apis)">
            {{ $t('label.update.static.routes') }}
          </a-button>
          <a-button
            style="margin-left: 10px"
            type="primary"
            danger
            @click="disableVpn = true"
            :disabled="!('deleteRemoteAccessVpn' in $store.getters.apis)">
            {{ $t('label.disable.vpn') }}
          </a-button>
        </div>

        <a-modal
          :visible="disableVpn"
          :footer="null"
          :title="$t('label.disable.vpn')"
          :closable="true"
          :maskClosable="false"
          @cancel="disableVpn = false">
          <div v-ctrl-enter="handleDisableVpn">
            <p>{{ $t('message.disable.vpn') }}</p>

            <a-divider />

            <div class="actions">
              <a-button @click="() => disableVpn = false">{{ $t('label.cancel') }}</a-button>
              <a-button type="primary" @click="handleDisableVpn">{{ $t('label.yes') }}</a-button>
            </div>
          </div>
        </a-modal>
        <a-modal
          :visible="addRoute"
          :footer="null"
          :title="$t('label.add.static.route')"
          :maskClosable="false"
          :closable="true"
          @cancel="addRoute = false">
          <div v-ctrl-enter="handleAddRoute">
            <a-input
              v-focus="true"
              v-model:value="routeValue"
              :placeholder="$t('label.cidr')">
            </a-input>
            <a-divider />
            <div class="actions">
              <a-button @click="() => addRoute = false">{{ $t('label.cancel') }}</a-button>
              <a-button type="primary" ref="submit" @click="handleAddRoute">{{ $t('label.yes') }}</a-button>
            </div>
          </div>
        </a-modal>

        <a-modal
          :visible="setManagementIp"
          :footer="null"
          :title="$t('label.set.management.ip')"
          :maskClosable="false"
          :closable="true"
          @cancel="setManagementIp = false">
          <div v-ctrl-enter="handleSetManagementIp">
            <a-input
              v-focus="true"
              v-model:value="managementIp"
              :placeholder="$t('label.cidr')">
            </a-input>
            <a-divider />
            <div class="actions">
              <a-button @click="() => setManagementIp = false">{{ $t('label.cancel') }}</a-button>
              <a-button type="primary" ref="submit" @click="handleSetManagementIp">{{ $t('label.yes') }}</a-button>
            </div>
          </div>
        </a-modal>
      </div>
      <div v-else>
        <div v-if="showIpDetails">
          <p>{{ $t('label.public.ip') }} <strong>{{ resource.ipaddress }}</strong></p>
         </div>
        <a-button
          :disabled="!('createRemoteAccessVpn' in $store.getters.apis)"
          type="primary"
          style="margin-left: 10px"
          @click="enableVpn = true">
          {{ $t('label.enable.vpn') }}
        </a-button>

        <a-modal
          :visible="enableVpn"
          :footer="null"
          :title="$t('label.enable.vpn')"
          :maskClosable="false"
          :closable="true"
          @cancel="enableVpn = false">
          <div v-ctrl-enter="handleCreateVpn">
            <p>{{ $t('message.enable.vpn') }}</p>
            <a-form-item>
              <a-checkbox
                v-model:checked="edgeVpn">
                {{ $t('label.edgevpn') }}
              </a-checkbox>
            </a-form-item>
            <a-form-item v-if="!edgeVpn">
              <a-checkbox v-model:checked="specifyIpRange">
                {{ $t('label.remote.access.vpn.specify.iprange') }}
              </a-checkbox>
            </a-form-item>
            <a-form-item
              v-if="specifyIpRange && !edgeVpn"
              name="iprange"
              :colon="false"
              ref="iprange">
              <template #label>
                <tooltip-label :title="$t('label.ip.range')" :tooltip="$t('message.remote.access.vpn.iprange.description')"/>
              </template>
              <a-input
                v-model:value="vpnIpRange"
                :placeholder="'10.1.2.1-10.1.2.8'"
              />
            </a-form-item>
            <a-form-item
              v-if="!edgeVpn"
              name="vpndns1"
              :colon="false"
              ref="vpndns1">
              <template #label>
                <tooltip-label :title="$t('label.ipv4.dns1')" :tooltip="$t('message.remote.access.vpn.dns1')"/>
              </template>
              <a-input
                v-model:value="vpnDns1"
                :placeholder="'1.1.1.1'"
              />
            </a-form-item>
            <a-form-item
              v-if="!edgeVpn"
              name="vpndns2"
              :colon="false"
              ref="vpndns2">
              <template #label>
                <tooltip-label :title="$t('label.ipv4.dns2')" :tooltip="$t('message.remote.access.vpn.dns2')"/>
              </template>
              <a-input
                v-model:value="vpnDns2"
                :placeholder="'8.8.8.8'"
              />
            </a-form-item>
            <a-form-item
              v-if="!edgeVpn"
              name="vpndnsdomain"
              :colon="false"
              ref="vpndnsdomain">
              <template #label>
                <tooltip-label :title="$t('label.ipv4.dns.domain')" :tooltip="$t('message.remote.access.vpn.dns.domain')"/>
              </template>
              <a-input
                v-model:value="vpnDnsDomain"
                :placeholder="'acme.inc'"
              />
            </a-form-item>
            <a-form-item
              v-if="!edgeVpn"
              name="vpndnsdomainsearch"
              :colon="false"
              ref="vpndnsdomainsearch">
              <template #label>
                <tooltip-label :title="$t('label.ipv4.dns.domain.search')" :tooltip="$t('message.remote.access.vpn.dns.domain.search')"/>
              </template>
              <a-input
                v-model:value="vpnDnsDomainSearch"
                :placeholder="'acme.inc,hq.acme.inc'"
              />
            </a-form-item>

            <a-divider />

            <div class="actions">
              <a-button @click="() => enableVpn = false">{{ $t('label.cancel') }}</a-button>
              <a-button type="primary" ref="submit" @click="handleCreateVpn">{{ $t('label.yes') }}</a-button>
            </div>
          </div>
        </a-modal>

      </div>
    </a-spin>
  </div>

</template>

<script>
import { getAPI, postAPI } from '@/api'
import TooltipLabel from '@/components/widgets/TooltipLabel'

export default {
  props: {
    showIpDetails: {
      type: Boolean,
      required: false
    },
    resource: {
      type: Object,
      required: true
    }
  },
  components: {
    TooltipLabel
  },
  data () {
    return {
      loading: false,
      remoteAccessVpn: null,
      enableVpn: false,
      disableVpn: false,
      vpnGateway: null,
      vpnGatewayEnabled: false,
      createVpnGateway: false,
      deleteVpnGateway: false,
      isSubmitted: false,
      specifyIpRange: false,
      vpnIpRange: '',
      edgeVpn: false,
      vpnDns1: '',
      vpnDns2: '',
      vpnDnsDomain: '',
      vpnDnsDomainSearch: '',
      routes: [],
      newRoutes: [],
      addRoute: false,
      routeValue: '',
      setManagementIp: false,
      managementIp: ''
    }
  },
  inject: ['parentFetchData', 'parentToggleLoading'],
  created () {
    this.fetchData()
  },
  watch: {
    resource: {
      deep: true,
      handler (newItem) {
        if (!newItem || !newItem.id) {
          return
        }
        this.fetchData()
      }
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      getAPI('listRemoteAccessVpns', {
        publicipid: this.resource.id,
        listAll: true
      }).then(response => {
        this.remoteAccessVpn = response.listremoteaccessvpnsresponse.remoteaccessvpn
          ? response.listremoteaccessvpnsresponse.remoteaccessvpn[0] : null
        this.loading = false
        this.fetchDetails()
      }).catch(error => {
        console.log(error)
        this.$notifyError(error)
        this.loading = false
      })
    },
    handleCreateVpn () {
      if (this.isSubmitted) return
      this.isSubmitted = true
      this.loading = true
      this.enableVpn = false
      const params = {
        publicipid: this.resource.id,
        domainid: this.resource.domainid,
        account: this.resource.account
      }
      if (this.specifyIpRange && !this.edgeVpn && this.vpnIpRange?.trim()) {
        params.iprange = this.vpnIpRange.trim()
      }
      postAPI('createRemoteAccessVpn', params).then(response => {
        this.$pollJob({
          jobId: response.createremoteaccessvpnresponse.jobid,
          successMethod: async result => {
            const res = result.jobresult.remoteaccessvpn
            this.$notification.success({
              message: this.$t('label.status'),
              description:
                `${this.$t('message.enabled.vpn')} ${'https://' + res.publichostname + ':' + res.publicport}.`,
              duration: 0
            })
            this.remoteAccessVpn = res
            var dns1Async = (this.vpnDns1 && this.isCidr(this.vpnDns1 + '/32') ? this.setVpnDetail('dns-server-1', this.vpnDns1) : '')
            var dns2Async = (this.vpnDns2 && this.isCidr(this.vpnDns2 + '/32') ? this.setVpnDetail('dns-server-2', this.vpnDns2) : '')
            var dnsDomainAsync = (this.vpnDnsDomain ? this.setVpnDetail('dns-domain', this.vpnDnsDomain) : '')
            var dnsDomainSearchAsync = (this.vpnDnsDomainSearch ? this.setVpnDetail('dns-domain-search', this.vpnDnsDomainSearch) : '')
            await dns1Async
            await dns2Async
            await dnsDomainAsync
            await dnsDomainSearchAsync
            if (this.vpnDns1 || this.vpnDns2 || this.vpnDnsDomain || this.vpnDnsDomainSearch) {
              this.updateRemoteAccessVpn({ async: true })
            }
            this.fetchData()
            this.loading = false
            this.isSubmitted = false
          },
          errorMessage: this.$t('message.enable.vpn.failed'),
          errorMethod: () => {
            this.fetchData()
            this.loading = false
            this.isSubmitted = false
          },
          loadingMessage: this.$t('message.enable.vpn.processing'),
          catchMessage: this.$t('error.fetching.async.job.result'),
          catchMethod: () => {
            this.fetchData()
            this.loading = false
            this.isSubmitted = false
          }
        })
      }).catch(error => {
        this.$notifyError(error)
        this.fetchData()
        this.isSubmitted = false
      })
    },
    handleDisableVpn () {
      if (this.isSubmitted) return
      this.isSubmitted = true
      this.loading = true
      this.disableVpn = false
      postAPI('deleteRemoteAccessVpn', {
        publicipid: this.resource.id,
        domainid: this.resource.domainid
      }).then(response => {
        this.$pollJob({
          jobId: response.deleteremoteaccessvpnresponse.jobid,
          successMessage: this.$t('message.success.disable.vpn'),
          successMethod: () => {
            this.fetchData()
            this.isSubmitted = false
          },
          errorMessage: this.$t('message.disable.vpn.failed'),
          errorMethod: () => {
            this.fetchData()
            this.isSubmitted = false
          },
          loadingMessage: this.$t('message.disable.vpn.processing'),
          catchMessage: this.$t('error.fetching.async.job.result'),
          catchMethod: () => {
            this.fetchData()
            this.isSubmitted = false
          }
        })
      }).catch(error => {
        this.$notifyError(error)
        this.fetchData()
        this.isSubmitted = false
      })
    },
    populateRoute (cidr, title, automatic) {
      this.newRoutes.push({ value: cidr, default: !!automatic, title })
    },
    fetchBaseRoutes (callback) {
      if (this.resource.vpcid) {
        getAPI('listVPCs', { id: this.resource.vpcid, listall: true }).then(response => {
          const vpc = response?.listvpcsresponse?.vpc?.[0]
          if (vpc) {
            this.populateRoute(vpc.cidr, 'vpc', true)
          }
        }).catch(error => {
          console.error(error)
          this.$message.error(this.$t('message.error.loading.setting'))
        }).finally(() => {
          if (!callback) return
          callback()
        })
      } else {
        if (this.resource.networkid) {
          getAPI('listNetworks', { id: this.resource.networkid, listall: true }).then(response => {
            const network = response.listnetworksresponse?.network?.[0]
            if (network) {
              this.populateRoute(network.cidr, 'network', true)
            }
          }).catch(error => {
            console.error(error)
            this.$message.error(this.$t('message.error.loading.setting'))
          }).finally(() => {
            if (!callback) return
            callback()
          })
        }
      }
    },
    fetchSiteToSiteRoutes (callback) {
      if (this.resource.vpcid) {
        getAPI('listVpnConnections', { vpcid: this.resource.vpcid, listall: true }).then(response => {
          const connections = response?.listvpnconnectionsresponse?.vpnconnection
          if (connections) {
            for (var i = 0; i < connections.length; i++) {
              var connection = connections[i]
              var cidrs = connection.cidrlist.split(',')
              for (var j = 0; j < cidrs.length; j++) {
                var cidr = cidrs[j]
                this.populateRoute(cidr, 'site to site', true)
              }
            }
          }
        }).catch(error => {
          console.error(error)
          this.$message.error(this.$t('message.error.loading.setting'))
        }).finally(() => {
          if (!callback) return
          callback()
        })
      }
    },
    fetchCustomRoutes (callback) {
      this.getVpnDetail('routes').then(item => {
        if (item) {
          var cidrs = item.split(',')
          for (var j = 0; j < cidrs.length; j++) {
            var cidr = cidrs[j]
            this.populateRoute(cidr, '', false)
          }
        }
      }).catch(error => {
        console.error(error)
        this.$message.error(this.$t('message.error.loading.setting'))
      }).finally(() => {
        if (!callback) return
        callback()
      })
    },
    fetchDetails (callback) {
      if (this.remoteAccessVpn) {
        this.loading = true
        this.newRoutes = []
        this.fetchBaseRoutes(() => {
          this.fetchSiteToSiteRoutes(() => {
            this.fetchCustomRoutes(() => {
              this.loading = false
              this.routes = this.newRoutes
            })
          })
        })
      }
    },
    updateRemoteAccessVpn ({ async }) {
      this.loading = !!async
      postAPI('updateRemoteAccessVpn', { id: this.remoteAccessVpn.id })
        .then(response => {
          if (!async) {
            this.$pollJob({
              jobId: response.updateremoteaccessvpnresponse.jobid,
              title: this.$t('label.updating.static.routes'),
              description: this.remoteAccessVpn.id,
              successMethod: () => { }
            })
          }
        })
        .catch(error => { console.error(error) })
        .finally(() => { this.loading = false })
    },
    isCidr (value) {
      var cidrparts = value.split('/')
      if (cidrparts.length !== 2) {
        return false
      }
      var parts = cidrparts[0].split('.')
      var ip = []
      for (var i = 0; i < parts.length; i++) {
        var subnet = parts[i]
        if (subnet) {
          for (var j = 0; j < subnet.length; j++) {
            if (!(subnet[j] >= '0' && subnet[j] <= '9')) {
              return false
            }
          }
          var ipval = parseInt(parts[i])
          if (ipval >= 0 && ipval <= 255) {
            ip.push(ipval)
          } else {
            return false
          }
        }
      }
      if (ip.length < 4) {
        return false
      }
      var mask = cidrparts[1] || ''
      for (var k = 0; k < mask.length; k++) {
        if (!(mask[k] >= '0' && mask[k] <= '9')) {
          return false
        }
      }
      var maskInt = parseInt(mask)
      if (maskInt > 32) {
        return false
      }
      return true
    },
    async deleteRoute (route) {
      var item = await this.getVpnDetail('routes')
      if (item) {
        var found = false
        var cidrs = item.split(',')
        for (var j = 0; j < cidrs.length; j++) {
          var cidr = cidrs[j]
          if (cidr === route.value) {
            found = true
          }
        }
        if (found) {
          var newRoutes = item.split(',').filter(p => p !== route.value).join(',')
          this.setVpnDetail('routes', newRoutes)
        }
      }
    },
    handleSetManagementIp () {
      var mgmtIp = this.managementIp
      this.managementIp = ''
      this.setManagementIp = false
      if (mgmtIp.indexOf('/') === -1) {
        mgmtIp = mgmtIp + '/32'
      }
      if (!this.isCidr(mgmtIp)) {
        return
      }
      this.setVpnDetail('management-ip', mgmtIp)
    },
    async handleAddRoute () {
      var route = this.routeValue
      this.routeValue = ''
      this.addRoute = false
      if (route.indexOf('/') === -1) {
        route = route + '/32'
      }
      if (!this.isCidr(route)) {
        return
      }
      var item = await this.getVpnDetail('routes')
      var newRoutes = ''
      var found = false
      if (item) {
        newRoutes = item
        var cidrs = newRoutes.split(',')
        for (var j = 0; j < cidrs.length; j++) {
          var cidr = cidrs[j]
          if (cidr === route) {
            found = true
          }
        }
      }
      if (!found) {
        if (newRoutes) newRoutes = newRoutes + ',' + route
        else newRoutes = route
        this.setVpnDetail('routes', newRoutes)
      }
    },
    async getVpnDetail (key) {
      const params = {
        resourceId: this.remoteAccessVpn.id,
        list: 'all',
        key: key
      }
      this.loading = true
      var response = await getAPI('listVpnDetails', params)
      var item = response?.listvpndetailsresponse?.resourcedetail?.[0]
      if (item) {
        return item.value
      }
      return null
    },
    async setVpnDetail (key, value) {
      const params = {
        resourceId: this.remoteAccessVpn.id,
        list: 'all',
        key: key
      }
      this.loading = true
      try {
        await postAPI('removeVpnDetail', params)
        await postAPI('addVpnDetail', {
          resourceId: this.remoteAccessVpn.id,
          'details[0].key': key,
          'details[0].value': value
        })
        this.fetchDetails()
      } catch (exc) {
        console.error(exc)
      }
      this.loading = false
    }
    // handleCreateVpnGateway () {
    //   if (this.isSubmitted) return
    //   this.isSubmitted = true
    //   this.parentToggleLoading()
    //   this.createVpnGateway = false
    //   const params = {
    //     vpcid: this.resource.vpcid,
    //     ipaddressid: this.resource.id
    //   }
    //   postAPI('createVpnGateway', params).then(response => {
    //     this.$pollJob({
    //       jobId: response.createvpngatewayresponse.jobid,
    //       successMessage: this.$t('message.success.add.vpn.gateway'),
    //       successMethod: result => {
    //         this.fetchData()
    //         this.parentToggleLoading()
    //         this.isSubmitted = false
    //       },
    //       errorMessage: this.$t('message.add.vpn.gateway.failed'),
    //       errorMethod: () => {
    //         this.fetchData()
    //         this.parentToggleLoading()
    //         this.isSubmitted = false
    //       },
    //       loadingMessage: this.$t('message.add.vpn.gateway.processing'),
    //       catchMessage: this.$t('error.fetching.async.job.result'),
    //       catchMethod: () => {
    //         this.fetchData()
    //         this.parentFetchData()
    //         this.parentToggleLoading()
    //         this.isSubmitted = false
    //       }
    //     })
    //   }).catch(error => {
    //     this.$notifyError(error)
    //     this.fetchData()
    //     this.parentFetchData()
    //     this.parentToggleLoading()
    //     this.isSubmitted = false
    //   })
    // },
    // handleDeleteVpnGateway () {
    //   if (this.isSubmitted) return
    //   this.isSubmitted = true
    //   this.parentToggleLoading()
    //   this.deleteVpnGateway = false
    //   postAPI('deleteVpnGateway', {
    //     id: this.vpnGateway.id
    //   }).then(response => {
    //     this.$pollJob({
    //       jobId: response.deletevpngatewayresponse.jobid,
    //       successMessage: this.$t('message.success.delete.vpn.gateway'),
    //       successMethod: () => {
    //         this.fetchData()
    //         this.parentToggleLoading()
    //         this.isSubmitted = false
    //       },
    //       errorMessage: this.$t('message.delete.vpn.gateway.failed'),
    //       errorMethod: () => {
    //         this.fetchData()
    //         this.parentToggleLoading()
    //         this.isSubmitted = false
    //       },
    //       catchMessage: this.$t('error.fetching.async.job.result'),
    //       catchMethod: () => {
    //         this.fetchData()
    //         this.parentFetchData()
    //         this.parentToggleLoading()
    //         this.isSubmitted = false
    //       }
    //     })
    //   }).catch(error => {
    //     this.$notifyError(error)
    //     this.fetchData()
    //     this.parentFetchData()
    //     this.parentToggleLoading()
    //     this.isSubmitted = false
    //   })
    // }
  }
}
</script>

<style scoped lang="scss">
  .actions {
    display: flex;
    justify-content: flex-end;

    button {
      &:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
  .vpn-details {
    padding: 8px 0;
  }
</style>
